export const CONTACT = {
  salesName: 'Junius',
  whatsappNumber: '6281286864825',
  phone: '+6281286864825',
  phoneDisplay: '+62 812-8686-4825',
  email: 'Juniushukky@gmail.com',
};

export const FLEET_CAMPAIGN = {
  enabled: true,
  path: '/fleet',
  defaultMessage:
    'Halo Junius, saya ingin meminta penawaran pembelian armada BYD untuk perusahaan. Kendaraan akan dibeli untuk bisnis rental atau operasional perusahaan.',
};

// Widget "Statistik Pengunjung" di footer. Menggunakan layanan counter publik
// tanpa backend; angka disimpan per namespace di server counter.
export const VISITOR_STATS = {
  enabled: true,
  endpoint: 'https://abacus.jasoncameron.dev',
  namespace: 'bydbsdserpong-com',
  // Angka awal total kunjungan, mis. 63361 untuk melanjutkan hitungan
  // dari counter lama. 0 = mulai dari nol.
  baseTotal: 0,
};

export function createWhatsAppUrl(message = FLEET_CAMPAIGN.defaultMessage) {
  return `https://api.whatsapp.com/send?phone=${CONTACT.whatsappNumber}&text=${encodeURIComponent(message)}`;
}
